import { useRef } from 'react';

/**
 * Phase 6e2a — THE forms→canvas JSON-diff snapshot throttle (parity 334;
 * §49.6 drawOnCanvas / §50.1 coil drawCoilConnections / evap_pack
 * drawConnections all gate their emissions on "payload JSON differs from the
 * cached snapshot"). This is the only thing preventing canvas redraw storms —
 * every render calls the emitter, only real payload changes pass through.
 *
 * Usage: const emitIfChanged = useJsonDiffEmit();
 *        emitIfChanged('coil:<id>', payload, () => bus.emit(...));
 */
export function useJsonDiffEmit(): (
  key: string,
  payload: unknown,
  emit: () => void
) => boolean {
  const snapshots = useRef(new Map<string, string>());
  return (key, payload, emit) => {
    const json = JSON.stringify(payload);
    if (snapshots.current.get(key) === json) return false;
    snapshots.current.set(key, json);
    emit();
    return true;
  };
}
